"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8683],{

/***/ 8683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1306);
/* harmony import */ var _modules_utils_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5379);
/* harmony import */ var _modules_api_home__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6346);
/* harmony import */ var _modules_state_home__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9441);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2713);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var Notice = function() {
    var t = (0,_modules_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("home").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var setIsNoticeModalOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useSetRecoilState */ .Zl)(_modules_state_home__WEBPACK_IMPORTED_MODULE_5__/* .IsNoticeModalOpen */ .G);
    var ref = (0,_modules_api_home__WEBPACK_IMPORTED_MODULE_6__/* .getNoticeListAPI */ .p)(), data = ref.data, error = ref.error;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), activeId = ref1[0], setActiveId = ref1[1];
    var handlePrevClick = function(e) {
        e.stopPropagation();
        if (activeId === 0) return;
        setActiveId(function(activeId) {
            return activeId - 1;
        });
    };
    var handleNextClick = function(e) {
        e.stopPropagation();
        if (data === undefined) return;
        if (!Array.isArray(data.data)) return;
        if (activeId === data.data.length - 1) return;
        setActiveId(function(activeId) {
            return activeId + 1;
        });
    };
    var handleTodayCloseClick = function() {
        (0,_modules_utils_cookie__WEBPACK_IMPORTED_MODULE_7__/* .setModalClose */ .lZ)("UNM");
        setIsNoticeModalOpen(false);
    };
    var handleContentsClick = function(e) {
        e.stopPropagation();
        if (data === undefined) return;
        if (!Array.isArray(data.data)) return;
        router.push(data === null || data === void 0 ? void 0 : data.data[activeId].popup_link);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (error) {
            setIsNoticeModalOpen(false);
        }
        if (data && !Array.isArray(data.data)) {
            setIsNoticeModalOpen(false);
        }
    }, [
        data,
        error
    ]);
    // useEffect(() => {
    //     if (fail) {
    //         setNoticeList([]);
    //         setIsNoticeModalOpen(false);
    //     }
    //
    //     if (success) {
    //         const { data } = success;
    //
    //         const tmp = [];
    //         for (let i = 0; i < data.length; i++) {
    //             tmp.push({ imageURL: data[i].popup_image, link: data[i].popup_link, exposure: data[i].exposure });
    //         }
    //         tmp.sort((i, j) => {
    //             return i.exposure - j.exposure;
    //         });
    //
    //         setNoticeList(tmp);
    //     }
    // }, [success, fail]);
    if (data === undefined) return null;
    if (!Array.isArray(data.data)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "presentation",
        onClick: function() {
            return setIsNoticeModalOpen(false);
        },
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().background),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().component),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    role: "presentation",
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().pagination),
                    children: data.data.map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return setActiveId(index);
                            },
                            className: activeId === index ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content_area),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            name: "prev",
                            disabled: activeId === 0,
                            onClick: handlePrevClick
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            role: "presentation",
                            src: data.data[activeId].popup_image,
                            width: 480,
                            height: 480,
                            alt: "update",
                            onClick: handleContentsClick
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            name: "next",
                            disabled: activeId === data.data.length - 1,
                            onClick: handleNextClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn_area),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        onClick: handleTodayCloseClick,
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().today_close),
                        children: t("noToday")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Notice);


/***/ }),

/***/ 6346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ mainSTSAPI; },
/* harmony export */   "p": function() { return /* binding */ getNoticeListAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7582);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8767);
/* harmony import */ var _modules_api_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5491);




var getNoticeList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _modules_api_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/utils/popuplist", {})
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getNoticeList() {
        return _ref.apply(this, arguments);
    };
}();
var getNoticeListAPI = function() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)("noticeList", function() {
        return getNoticeList();
    }, {
        retry: false
    });
};
var STS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, duration, speaker) {
        var formData, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = new FormData();
                    formData.append("file", file);
                    formData.append("duration", String(duration));
                    formData.append("speaker", speaker);
                    return [
                        4,
                        _modules_api_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/utils/sound_experience", formData)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function STS(file, duration, speaker) {
        return _ref.apply(this, arguments);
    };
}();
var mainSTSAPI = function() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function(param) {
        var file = param.file, duration = param.duration, speaker = param.speaker;
        return STS(file, duration, speaker);
    });
};


/***/ })

}]);